import * as Styles from './brand-button.styles';

export type ButtonTypes = 'primary' | 'secondary' | 'ghost' | 'empty';

export interface BrandButtonProps {
  type?: ButtonTypes;
  onPress?: () => void;
  icon?: 'remove' | 'add' | 'go';
  title?: string;
  label?: string;
  children?: any;
  showIcon?: boolean;
}
const iconMap = {
  remove: '/icons/close.svg',
  add: '/icons/plus.svg',
  go: '/icons/arrowIcon.svg',
};

export function BrandButton({
  type = 'primary',
  onPress,
  icon,
  title,
  label,
  children,
  showIcon = true,
}: BrandButtonProps) {
  return (
    <Styles.Button
      aria-disabled={true}
      type={children ? 'ghost' : type}
      onClick={onPress}
      showIcon={showIcon}

    >
      {type === 'empty' && <Styles.Layer></Styles.Layer>}
      {children ? (
        children
      ) : (
        <>
          {title}
          <Styles.Row>
            {label && <Styles.Label>{label}</Styles.Label>}
            {showIcon&& icon && (
              <Styles.Icon
                removeBackGround={type === 'empty'}
                src={iconMap[icon]}
              />
            )}
          </Styles.Row>
        </>
      )}
    </Styles.Button>
  );
}

export default BrandButton;
